<template>
  <div class="activity">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span>
          liked
          <DUserLinkPopup
            :user-id="sourceId"
          >
            <template slot="content">
              <a
                class="resource-link"
                :href="activity.source.url"
                target="_blank"
              >{{ sourceUsername }}</a>'s update
            </template>
          </DUserLinkPopup>
        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />
    </div>
  </div>
</template>

<script>
import activityMixin from '../shared/activity-mixin';
import DUserLinkPopup from '@d-components/d-user-link-popup/d-user-link-popup.vue';

export default {
  components: {
    DUserLinkPopup,
  },
  mixins: [
    activityMixin,
  ],
  data: () => ({
    sourceUsername: null,
    sourceId: '',
  }),
  mounted() {
    const sourceUsername = this.activity.source.user.firstname ?
      `${ this.activity.source.user.firstname } ${ this.activity.source.user.lastname }` :
      this.activity.source.user;

    const sourceId = typeof this.activity.source.user === 'string' ?
      this.activity.source.user :
      this.activity.source.user.id;

    this.$set(this, 'sourceUsername', sourceUsername);
    this.$set(this, 'sourceId', sourceId);
  },
};
</script>

